module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"page_title":"Восстановление пароля","password_reset":"Восстановление пароля","enter_email":"Введите адрес электронной почты, который зарегистрирован у нас на сайте","password_reset_button":"Восстановить пароль"},"en":{"page_title":"Reset password","password_reset":"Reset password","enter_email":"Enter an email registered on our site","password_reset_button":"Reset password"}}')
  delete Component.options._Ctor
}
